import React from 'react';
import classnames from 'classnames';
import SiteFooter from '@wix/da-shared-react/pkg/SiteFooter';
import { BiDataHook } from '@wix/da-bi/pkg/constants';
import type { BIEventPayload } from '@wix/da-bi/pkg/types';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import Header from '../../../Header';
import NetworkBarWrapper from '../NetworkBarWrapper';
import ScrollDependentStickyContainer from '../../../ScrollDependentStickyContainter';
import s from './PageContainer.scss';

export interface Props {
  title?: React.ReactNode;
  tagLine?: React.ReactNode;
  customHeader?: React.ReactNode;
  headerNavigation?: React.ReactNode;
  headerLeftSideContent?: React.ReactNode;
  headerRightSideContent?: React.ReactNode;
  headerIsStickyOnScrollUp?: boolean;
  withNavigation?: boolean;
  withNetworkBar?: boolean;
  withTabHeader?: boolean;
  isSearchPage?: boolean;
  withFooter?: boolean;
  className?: string;
  titleClassName?: string;
  biData?: BIEventPayload;
  children?: React.ReactNode;
}

const PageContainer: React.FC<Props> = ({
  children,
  withTabHeader = true,
  isSearchPage,
  withFooter = false,
  className,
  title,
  tagLine,
  headerNavigation,
  headerRightSideContent,
  headerLeftSideContent,
  withNetworkBar = true,
  biData: { itemid: sectionid, typeid: section_typeid, ...biData } = {},
  withNavigation,
  titleClassName,
  customHeader,
  headerIsStickyOnScrollUp = false,
}) => {
  return (
    <NetworkBarWrapper
      isNetworkBarEnabled={withNetworkBar}
      className={classnames(
        s['root'],
        !withFooter && !withNetworkBar && s['no-footer-page']
      )}
    >
      <BiLoggerContextProvider value={{ sectionid, section_typeid, ...biData }}>
        {headerIsStickyOnScrollUp && (
          <ScrollDependentStickyContainer className={s['scroll-sticky']}>
            {customHeader}
            {withTabHeader && (
              <Header
                title={title}
                tagline={tagLine}
                rightSideContent={headerRightSideContent}
                leftSideContent={headerLeftSideContent}
                className={s['header']}
                withNavigation={withNavigation}
                titleClassName={titleClassName}
                isSticky={false}
              >
                {headerNavigation}
              </Header>
            )}
          </ScrollDependentStickyContainer>
        )}
        {!headerIsStickyOnScrollUp && (
          <>
            {customHeader}
            {withTabHeader && (
              <Header
                title={title}
                tagline={tagLine}
                rightSideContent={headerRightSideContent}
                leftSideContent={headerLeftSideContent}
                className={s['header']}
                withNavigation={withNavigation}
                titleClassName={titleClassName}
              >
                {headerNavigation}
              </Header>
            )}
          </>
        )}
        <div
          className={classnames(
            s['page'],
            isSearchPage && s['search'],
            withTabHeader && s['with-header']
          )}
          data-hook={BiDataHook.BROWSE_ALL_CONTENT}
        >
          <div className={className}>{children}</div>
        </div>
      </BiLoggerContextProvider>
      {withFooter && <SiteFooter />}
    </NetworkBarWrapper>
  );
};
PageContainer.displayName = 'PageContainer';

export default PageContainer;
